import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import usePages from '../../context/PageContext';
import masterDataService from '../../service/masterData.service';
import useMenus from '../../context/MenuContext';
import useParam from '../../context/ParamContext';
import useUsers from '../../context/UsersContext';
import { Box } from '@mui/material';
import { sxConfig } from './projectTypeHome.style';

export const ProjectTypeHomePage = () => {
  const { setPages } = usePages();
  const { menus, getSubMenuNamesByUrls } = useMenus();
  const { params, getParam } = useParam();
  const { user, getUser } = useUsers();
  const navigate = useNavigate();
  const [types, setTypes] = useState([]);

  useEffect(() => {
    getTypes();
    if (!Object.keys(user).length) getUser();
    getParam();
  }, []);

  const getTypes = () => {
    masterDataService.homePageProjectTypeToForm().then((data) => {
      setTypes(data);
    });
  };

  const submenuNames = useMemo(() => {
    return getSubMenuNamesByUrls(['taskkanban']);
  }, [menus]);

  const handleNavigate = (projectTypeId) => {
    const roleIds = params.PROJECT_TYPE_HOME_PAGE_ADMIN ? JSON.parse(params.PROJECT_TYPE_HOME_PAGE_ADMIN) : [];

    if (roleIds.includes(user.roleId)) {
      navigate(`/app/taskkanban/Project/${projectTypeId}`);
    } else {
      navigate(`/app/taskkanban/taskList/${projectTypeId}`);
    }
    setPages({ subMenuName: submenuNames[0] });
  };

  return (
    <Box sx={sxConfig.container}>
      <Box sx={sxConfig.wrapper}>
        {types?.map((type) => (
          <Box key={type.id} onClick={() => handleNavigate(type.id)} sx={sxConfig.contentBox}>
            <Box sx={sxConfig.contextText}>{type.name}</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
